// LoggedOutHero.tsx — Phase 11 Step 3 Block 5
// Editorial-Greeting oberhalb des Feeds für ausgeloggte Besucher.
// Source-of-truth: Scrolly Platform.html `LoggedOutHero` (HomeFeed-Abschnitt).
//
// Liegt bewusst in `components/home/` (nicht `components/feed/`) — das Briefing
// nennt das als Option, weil der Hero vom Home-Context spricht
// (Plattform-Greeting), nicht vom Feed-Kontext (Scrolly-Rails).

import { FONT_DISPLAY, PINK, VARIANT } from "../../lib/tokens";
import { useVariant } from "../../hooks/useVariant";

export function LoggedOutHero() {
  const { variant } = useVariant();
  const v = VARIANT[variant];
  const isDark = variant === "immersive";

  return (
    <div
      style={{
        padding: "40px 0 28px",
        textAlign: "center",
        maxWidth: 820,
        margin: "0 auto",
      }}
    >
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 6,
          background: isDark ? "rgba(255,51,102,0.15)" : "#fef1f4",
          color: PINK,
          padding: "5px 12px",
          borderRadius: 999,
          fontSize: 12,
          fontWeight: 600,
          letterSpacing: 0.3,
        }}
      >
        Die Heimat scrollbarer Inhalte
      </div>
      <h1
        style={{
          fontFamily: FONT_DISPLAY,
          fontSize: 72,
          fontWeight: 500,
          color: v.text,
          margin: "16px 0 12px",
          letterSpacing: -2,
          lineHeight: 0.95,
        }}
      >
        Geschichten, die sich{" "}
        <em style={{ color: PINK, fontStyle: "italic" }}>bewegen</em>, wenn du
        scrollst.
      </h1>
      <p
        style={{
          color: v.muted,
          fontSize: 17,
          lineHeight: 1.5,
          margin: "0 auto",
          maxWidth: 560,
        }}
      >
        Datenstorys, Erklärstücke, Brand-Welten, Anleitungen — gebaut für die
        Art, wie du schon liest. Millionen von Scrollys von Creatorn weltweit,
        oder bau dein eigenes in Minuten.
      </p>
    </div>
  );
}
